export default __webpack_public_path__ + "static/media/KDS.e4e6494d.png";